'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function COFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-b51nhjx1r", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-sa3o3cfj7", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-0i03tg9ej" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-0i03tg9ej", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-b51nhjx1r)" }, /* @__PURE__ */ React.createElement("use", { fill: "#2e42a5", xlinkHref: "#mantine-0i03tg9ej" }), /* @__PURE__ */ React.createElement("path", { fill: "#feca00", d: "M0 0h32v12H0z", mask: "url(#mantine-sa3o3cfj7)" }), /* @__PURE__ */ React.createElement("path", { fill: "#e31d1c", d: "M0 18h32v6H0z", mask: "url(#mantine-sa3o3cfj7)" })))
  );
}

export { COFlag };
//# sourceMappingURL=CO.mjs.map
